const state = {
  status: false
}

// getters
const getters = {
  getStatus: state => state.status
}

// actions
const actions = {
  updatestatus ({ state, commit }, product) {
    commit('setstatus', false)
  }
}

// mutations
const mutations = {
  setstatus (state, status) {
    state.checkoutStatus = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/teacher.js